import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useCapabilities } from '../hooks/useCapabilities';
import { useInvoiceV2Enabled } from '../services/invoiceV2';
import { WHATSAPP_ATTACHMENT_PARAM } from '../services/invoiceWhatsApp';
import Login from './Login';
import InvoiceWorkspace from './InvoiceWorkspace';
import SessionStatus from './SessionStatus';

// This entry point shares authentication, without mounting the attention console.
export default function ESaveApp() {
    const { token, loading, login, logout, sessionError, retrySession } = useAuth();
    const { hasCapability } = useCapabilities();
    const enabled = useInvoiceV2Enabled(hasCapability('gestion_facturas'));
    const [attachment] = useState(() => {
        const id = new URLSearchParams(window.location.search).get(WHATSAPP_ATTACHMENT_PARAM);
        return id ? { id } : null;
    });
    useEffect(() => { document.title = 'ESave'; }, []);
    const clearAttachment = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete(WHATSAPP_ATTACHMENT_PARAM);
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    };
    if (loading || sessionError) return <SessionStatus loading={loading} error={sessionError} onRetry={retrySession} onLogout={logout} />;
    if (!token) return <Login onLoginSuccess={login} returnTo={window.location.pathname + window.location.search} />;
    if (!enabled) return <p role="status">ESave no está disponible para tu usuario o no está habilitado.</p>;
    return <main className="esave-standalone"><InvoiceWorkspace standalone onLogout={logout} initialAttachment={attachment} onAttachmentHandled={clearAttachment} /></main>;
}
